import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilterDesc: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="filter-desc"><path d="M3.75 5.75H18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 12H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 18.25H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18 10.75V18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.75 15.75L18 19L21.25 15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFilterDesc;
